import React from 'react';
import { Box, Typography } from '@mui/material';
import type { HubSpotImportSourceConfig } from '../../../api/campaignScheduledJobs';

/**
 * Reads HubSpot `source_config` from merged job config (top-level or under `job_config`).
 */
export function getHubSpotSourceConfigFromJobConfig(
  config: Record<string, unknown>
): HubSpotImportSourceConfig | undefined {
  if (config.source_type !== 'hubspot_import') return undefined;
  return config.source_config as HubSpotImportSourceConfig;
}

interface HubSpotImportMappingSummaryProps {
  sourceConfig: HubSpotImportSourceConfig | null | undefined;
}

/**
 * Read-only HubSpot import mapping (primary, scope, field → column list).
 * Same content as the mapping section in Edit schedule.
 */
const HubSpotImportMappingSummary: React.FC<
  HubSpotImportMappingSummaryProps
> = ({ sourceConfig }) => {
  if (!sourceConfig) return null;
  const primary = sourceConfig.import_mapping.find((m) => m.is_primary)!;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
        HubSpot import mapping
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Primary: {primary.campaign_column} ← {primary.hubspot_property} · Scope:{' '}
        {sourceConfig.scope}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0 }}>
        {sourceConfig.import_mapping
          .map(
            (m) =>
              `${m.hubspot_property} → ${m.campaign_column}${
                m.is_primary ? ' (primary)' : ''
              }`
          )
          .join(', ')}
      </Typography>
    </Box>
  );
};

export default HubSpotImportMappingSummary;
